export default {
  computed: {
    yearSelect() {
      return {
        raw: this.years,
        options: this.years
          ? Object.keys(this.years).map(key => ({
              label: this.years[key],
              value: key
            }))
          : null,
        placeholder: this.$l10n("YEAR"),
        handler: year => {
          const query = { ...this.$route.query };

          if (year) {
            query.year = year;
          } else {
            delete query.year;
          }

          this.$router.push({
            path: this.$route.path,
            query
          });
        }
      };
    }
  }
};
